var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import './ActionBar.scss';
const ActionBar = ({ children }) => React.createElement("div", { className: "actionbar-container" }, children);
ActionBar.Button = (_a) => {
    var { children, loading = false } = _a, rest = __rest(_a, ["children", "loading"]);
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Button, Object.assign({ size: "medium" }, rest),
        children,
        loading && React.createElement(CircularProgress, { size: 20 })));
};
export default ActionBar;
